module.exports = __webpack_public_path__ + "static/media/samuraiDavie2.486dc733.pdf";